import(/* webpackChunkName: "login-form-controller" */ './login-form-controller');
import(/* webpackChunkName: "welcome-modal" */ './welcome-modal');

if (document.querySelector('login-error-message')) {
  import(/* webpackChunkName: "login-error-message" */ './login-error-message');
}

if (document.querySelector('form.potential-login-email-form')) {
  import(/* webpackChunkName: "potential-login-email-form" */ './potential-login-email-form')
    .then((module) => module.default());
}

if (document.querySelector('sg-a-context')) {
  import(/* webpackChunkName: "sg-a-context" */ './sg-a-context')
    .catch(error => {
      console.error('Error loading auth context:', error);
    });
}

if (document.querySelector('edit-profile-form-controller')) {
  import(/* webpackChunkName: "edit-profile-form-controller" */ './edit-profile-form-controller');
}

if (document.querySelector('questions-modal')) {
  import(/* webpackChunkName: "questions-modal" */ './questions-modal');
}